import { render, staticRenderFns } from "./cta-row.vue?vue&type=template&id=a834b838&scoped=true&"
import script from "./cta-row.vue?vue&type=script&lang=js&"
export * from "./cta-row.vue?vue&type=script&lang=js&"
import style0 from "./cta-row.vue?vue&type=style&index=0&id=a834b838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a834b838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a834b838')) {
      api.createRecord('a834b838', component.options)
    } else {
      api.reload('a834b838', component.options)
    }
    module.hot.accept("./cta-row.vue?vue&type=template&id=a834b838&scoped=true&", function () {
      api.rerender('a834b838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/cta-row.vue"
export default component.exports